export function createCmdHistory() {
    return {
        a: null,
        b: null,
    };
}
//# sourceMappingURL=createCmdHistory.js.map